import { X } from 'lucide-react';
import * as React from 'react';
import type { Credential } from '../../../interfaces/user.interface';

const CURRENT_YEAR = new Date().getFullYear();
export const CREDENTIAL_YEAR_MAX = CURRENT_YEAR + 5;
export const CREDENTIAL_EXPIRY_YEAR_MAX = CURRENT_YEAR + 50;
const MAX_YEAR = CREDENTIAL_YEAR_MAX;

interface Props {
  value: Credential;
  onChange: (next: Credential) => void;
  onRemove: () => void;
  error?: string | null;
}

export function CredentialRow({
  value,
  onChange,
  onRemove,
  error,
}: Props): React.ReactElement {
  const update = (patch: Partial<Credential>): void =>
    onChange({ ...value, ...patch });

  return (
    <div className="plan-c-form__credential-row" data-credential-id={value.id}>
      <div className="plan-c-form__credential-grid">
        <input
          type="text"
          placeholder="Title *"
          maxLength={150}
          value={value.title}
          onChange={(e) => update({ title: e.target.value })}
          className="plan-c-form__input"
          aria-label="Credential title"
        />
        <input
          type="text"
          placeholder="Issuer *"
          maxLength={150}
          value={value.issuer}
          onChange={(e) => update({ issuer: e.target.value })}
          className="plan-c-form__input"
          aria-label="Credential issuer"
        />
        <input
          type="number"
          placeholder={`Year * (1900–${MAX_YEAR})`}
          min={1900}
          max={MAX_YEAR}
          value={value.year || ''}
          onChange={(e) => update({ year: Number(e.target.value) })}
          className="plan-c-form__input"
          aria-label="Credential year"
        />
        <input
          type="number"
          placeholder="Expires (optional)"
          min={1900}
          max={CREDENTIAL_EXPIRY_YEAR_MAX}
          value={value.expiryYear ?? ''}
          onChange={(e) =>
            update({
              expiryYear: e.target.value ? Number(e.target.value) : undefined,
            })
          }
          className="plan-c-form__input"
          aria-label="Credential expiry year"
        />
        <input
          type="url"
          placeholder="Verification link (optional)"
          value={value.link ?? ''}
          onChange={(e) => update({ link: e.target.value || undefined })}
          className="plan-c-form__input"
          aria-label="Credential verification link"
        />
      </div>
      {error ? (
        <p className="plan-c-form__credential-error" role="alert">
          {error}
        </p>
      ) : null}
      <button
        type="button"
        onClick={onRemove}
        aria-label="Remove credential"
        className="plan-c-form__credential-remove"
      >
        <X size={16} />
      </button>
    </div>
  );
}
